import React from 'react';
export const Science = () => {
  return <div className="w-full bg-gray-100 py-12 Science" data-id="element-124">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-125">
        <h2 className="text-2xl md:text-3xl font-bold text-green-900 text-center mb-8" data-id="element-126">
          The Hidden Connection: How Your Dog's Ancestral Diet Holds the Key
        </h2>
        <p className="text-gray-700 text-center max-w-4xl mx-auto mb-12" data-id="element-127">
          Here's something most vets won't tell you: Modern dogs are suffering
          from what we call "Modern Diet Deficiency." For thousands of years,
          dogs thrived on a diet rich in organ meats, diverse proteins, and
          natural probiotics from the soil and their prey's digestive systems.
        </p>
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-12" data-id="element-128">
          <h3 className="text-xl font-bold text-green-900 mb-6" data-id="element-129">
            The Science Behind The Daily Foundation Chew™
          </h3>
          <p className="text-gray-700 mb-6" data-id="element-130">
            Our breakthrough formula addresses bad breath at its source with
            three powerful systems working in harmony:
          </p>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-131">
            <div className="bg-green-50 p-5 rounded-lg" data-id="element-132">
              <h4 className="font-bold text-green-800 mb-3" data-id="element-133">
                The Gut-Balancing Complex
              </h4>
              <ul className="space-y-2" data-id="element-134">
                <li className="text-sm" data-id="element-135">
                  <span className="font-semibold" data-id="element-136">Soil-Based Probiotics:</span>{' '}
                  Unlike fragile regular probiotics that die in stomach acid,
                  these resilient spore-forming bacteria actually reach the gut
                  alive.
                </li>
                <li className="text-sm" data-id="element-137">
                  <span className="font-semibold" data-id="element-138">Organic Spirulina:</span> Acts
                  as a natural internal deodorizer while feeding beneficial
                  bacteria.
                </li>
              </ul>
            </div>
            <div className="bg-green-50 p-5 rounded-lg" data-id="element-139">
              <h4 className="font-bold text-green-800 mb-3" data-id="element-140">
                The Ancestral Core Blend™
              </h4>
              <ul className="space-y-2" data-id="element-141">
                <li className="text-sm" data-id="element-142">
                  <span className="font-semibold" data-id="element-143">
                    Freeze-dried Grass-Fed Organs:
                  </span>{' '}
                  Liver, heart, and kidney provide the essential nutrients
                  modern diets lack.
                </li>
                <li className="text-sm" data-id="element-144">
                  <span className="font-semibold" data-id="element-145">Rich in B-vitamins:</span>{' '}
                  Naturally combat odor-causing bacteria.
                </li>
              </ul>
            </div>
            <div className="bg-green-50 p-5 rounded-lg" data-id="element-146">
              <h4 className="font-bold text-green-800 mb-3" data-id="element-147">
                The Total Wellness Matrix
              </h4>
              <ul className="space-y-2" data-id="element-148">
                <li className="text-sm" data-id="element-149">
                  <span className="font-semibold" data-id="element-150">
                    Green-Lipped Mussel & CurcuVET®:
                  </span>{' '}
                  Reduces system-wide inflammation that can worsen digestive
                  issues.
                </li>
                <li className="text-sm" data-id="element-151">
                  <span className="font-semibold" data-id="element-152">
                    Creates an internal environment:
                  </span>{' '}
                  Where healthy bacteria thrive.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-153">
          <button className="bg-amber-600 text-white font-semibold py-3 px-8 rounded-full hover:bg-amber-500 transition" onClick={() => {
          document.querySelector('.Timeline')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-154">
            Get The Daily Foundation Chew™
          </button>
        </div>
      </div>
    </div>;
};